module.exports = __webpack_public_path__ + "static/media/5.question.ccd5e5b1.mp4";